export default "__VITE_ASSET__CEfZ6pm2__"